import React from 'react';
import Text from '../../../Base/Text/Text';
import { useValidation } from '../../../Utils/Validation';
//@ts-ignore
import styles from './ErrorMessage.module.scss';

interface Props {
	tx: string;
}

const ErrorMessage = ({ tx }: Props) => (
	<div className={styles.errorMessage}>
		<Text tx={tx} inline />
	</div>
);

export default ErrorMessage;
